module.exports = __webpack_public_path__ + "static/media/iq.60c7290f.svg";